import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DropdownAutocomplete from 'components/DropdownAutocomplete';
import LoadingSpinner from 'components/LoadingSpinner';
import useFetchTimeSeriesSet from 'hooks/useApi/useFetchTimeSeriesSets';

const TimeSeriesSetIdSelector = ({ handleSelect, dashboardData, timeSeriesSetId }) => {
  const [options, isError, isLoading] = useFetchTimeSeriesSet();
  const {
    masterObjectTimeSeriesSetId,
    masterObjectId,
    timeSeriesSetId: dashboardTimeSeriesSet
  } = dashboardData;
  const [selectedOption, setSelectedOption] = useState(
    dashboardTimeSeriesSet || timeSeriesSetId || masterObjectTimeSeriesSetId
  );

  useEffect(() => {
    if (masterObjectTimeSeriesSetId) {
      setSelectedOption(masterObjectTimeSeriesSetId);
    }
  }, [masterObjectId, masterObjectTimeSeriesSetId]);

  useEffect(() => {
    if (selectedOption !== dashboardTimeSeriesSet && dashboardTimeSeriesSet !== undefined) {
      setSelectedOption(dashboardTimeSeriesSet);
    }
  }, [dashboardTimeSeriesSet]);

  useEffect(() => {
    if (selectedOption !== timeSeriesSetId) {
      setSelectedOption(timeSeriesSetId);
    }
  }, [timeSeriesSetId]);

  const handleSelected = selected => {
    setSelectedOption(selected.value);
    handleSelect(selected.value);
  };

  return (
    <>
      {options === null || options === undefined || isError || isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <DropdownAutocomplete
            selected={selectedOption}
            options={options}
            onSelect={handleSelected}
            minWidth="220px"
            type="selectedOptionType"
            listBoxHeight="360px"
            name="selectedOption"
            label="Choose..."
          />
        </>
      )}
    </>
  );
};

TimeSeriesSetIdSelector.propTypes = {
  handleSelect: PropTypes.func.isRequired,
  dashboardData: PropTypes.shape({
    timeSeriesSetId: PropTypes.number,
    masterObjectTimeSeriesSetId: PropTypes.number,
    masterObjectId: PropTypes.number
  }),
  timeSeriesSetId: PropTypes.number
};

TimeSeriesSetIdSelector.defaultProps = {
  dashboardData: {
    timeSeriesSetId: null,
    masterObjectTimeSeriesSetId: null,
    masterObjectId: null
  },
  timeSeriesSetId: null
};

export default TimeSeriesSetIdSelector;
